import { isCliImmediateShutdownRequested } from '../../runtime/cli-process-interrupt.js';

/** Monotonic epoch; bumped to invalidate in-flight capability warmup/probe work. */
let warmupEpoch = 0;

/** Cancel any in-flight capability warmup from a prior bridge connect or reconnect. */
export function cancelInFlightAgentCapabilityWarmup(): void {
  warmupEpoch += 1;
}

/** Start a new warmup generation and return a predicate for whether this run is still current. */
export function beginAgentCapabilityWarmupRun(): () => boolean {
  const epoch = (warmupEpoch += 1);
  return () => epoch === warmupEpoch && !isCliImmediateShutdownRequested();
}

/** Vitest: reset warmup epoch between tests. */
export function resetAgentCapabilityWarmupRunForTests(): void {
  warmupEpoch = 0;
}
